export const loadReducer = (state = {}, action = {}) => {
  if (action.meta.request) {
    return { loadingId: action.meta.transactionId };
  }

  if ((state && state.loadingId) !== action.meta.transactionId) {
    return state;
  }

  if (action.error) {
    return { error: action.payload };
  }

  return { ...state, data: action.payload, loadingId: null, error: null };
};
